import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useSearchParams } from 'react-router-dom' // Replaces useQueryParam
import { IconButton, Input, InputAdornment } from '@mui/material'
import { Search } from '@mui/icons-material'

const SearchForm = ({ full }) => {
  const navigate = useNavigate() 
  const location = useLocation()
  const [searchParams, setSearchParams] = useSearchParams() // Replaces useQueryParam
  const query = searchParams.get('query') || '' // Get query param
  const [q, setQ] = useState(query)

  const handleSearch = (e) => {
    e.preventDefault()
    if (!q) return

    if (location.pathname.startsWith('/search')) {
      setSearchParams({ query: q }) // Updates the query param
    } else {
      navigate(`/search?query=${q}`) // Redirects with query
    }
  }

  return (
    <form onSubmit={handleSearch} style={{ maxWidth: full ? 1000 : 500, width: '100%' }}>
      <Input
        color="primary"
        disableUnderline
        fullWidth
        inputProps={{
          style: {
            padding: 16,
            background: '#ededed',
          },
          "aria-label": "search offers"
        }}
        placeholder="Search offers"
        endAdornment={
          <InputAdornment position="end">
            <IconButton aria-label="Search" type="submit" size="large">
              <Search />
            </IconButton>
          </InputAdornment>
        }
        style={{
          padding: '0 8px',
          background: '#ededed',
          borderRadius: 4,
          marginRight: 8,
        }}
        onChange={e => setQ(e.target.value)}
        value={q}
      />
    </form>
  )
}

export default SearchForm
